import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';

export interface MyTeamMembersMenuItemProps {
    className?: string;
    marginLeft?: number;
}

export const MyTeamMembersMenuItem = (props: MyTeamMembersMenuItemProps) => (
    <LeftMenuItem
        icon="pe-7s-add-user"
        label="My Team Members"
        to="/associates"
        className={props.className}
        marginLeft={props.marginLeft}
        trackingAction="My Team Members"
    />
);
